import TagsModel from './TagsModel'

export default class TagsListModel {
  constructor (data) {
    if (Array.isArray(data)) {
      const campaignList = this.groupBy(data, 'campaignId')
      this.campaigns = Object.keys(campaignList)
      this.list = this.campaigns.reduce((map, campaign) => {
        const categoryList = this.groupBy(campaignList[campaign], 'name')
        const categories = Object.keys(categoryList)
        return {
          ...map,
          [campaign]: { categoryList, categories }
        }
      }, {})
      this.campaignsData = Object.keys(campaignList).reduce((map, key) => ({
        ...map,
        [key]: this.list[key].categoryList.Total[0].campaignName
      }), {})
    }
  }

  groupBy (array, key) {
    /**
     * data = [{ name: "A", value: "1"}, { name: "A", value: "2"}]
     * groupBy(data, "name") => { A: [{ name: "A", value: "1"}, { name: "A", value: "2"}] }
     */
    return array.reduce((result, item) => {
      (result[item[key]] = result[item[key]] || []).push(new TagsModel(item))
      return result
    }, {})
  }
}



// WEBPACK FOOTER //
// ./src/api/campaigns/TagsListModel.js